import { type CreatorPortfolio, DEFAULT_COVER_CROP } from "./types";

// Real public posts, also used in X's embed documentation. The profile and
// collection framing are explicitly illustrative; authorship belongs to each
// post.
//
export const demoCreatorPortfolio: CreatorPortfolio = {
  version: 2,
  profile: {
    id: "highlighted-example",
    handle: "example",
    name: "Example portfolio",
    role: "A tour of Highlighted FYI",
    bio: "Real X posts, arranged in sample collections with optional context. The original authors are credited in each embed. This is not their portfolio or an endorsement.",
    website: "",
    location: "",
    ctaLabel: "Create your portfolio",
    ctaUrl: "https://highlighted.fyi/studio",
  },
  collections: [
    {
      id: "demo-guides",
      slug: "guides",
      title: "Guides",
      note: "A collection of linked resources with optional context about who they help and why they matter.",
      accent: "marigold",
      layout: "feed",
      isPublic: true,
      updatedAt: "2026-09-13T00:00:00.000Z",
      cover: "",
      coverSource: "",
      coverCrop: { ...DEFAULT_COVER_CROP },
      postIds: ["demo-guide"],
      postMetadata: {
        "demo-guide": {
          title: "A guide to timeline endpoints",
          note: "Sample context: explain who this resource helps, your contribution, and why you selected it. This actual post comes from X’s developer account.",
        },
      },
    },
    {
      id: "demo-artworks",
      slug: "artworks",
      title: "Visual work",
      note: "Photo posts in a Grid. The X embed keeps the image and its attribution together.",
      accent: "plum",
      layout: "grid",
      isPublic: true,
      updatedAt: "2026-09-13T00:00:00.000Z",
      cover: "",
      coverSource: "",
      coverCrop: { ...DEFAULT_COVER_CROP },
      postIds: ["demo-photo"],
      postMetadata: {
        "demo-photo": {
          title: "Grand Teton at sunset",
          note: "Sample caption: add the setting or the story behind a visual project. This photograph was posted by the U.S. Department of the Interior.",
        },
      },
    },
    {
      id: "demo-styles",
      slug: "styles",
      title: "Field notes",
      note: "Short posts can sit alongside resources, with a different note in each collection.",
      accent: "tide",
      layout: "feed",
      isPublic: true,
      updatedAt: "2026-09-13T00:00:00.000Z",
      cover: "",
      coverSource: "",
      coverCrop: { ...DEFAULT_COVER_CROP },
      postIds: ["demo-text", "demo-guide"],
      postMetadata: {
        "demo-text": {
          title: "A small beginning",
          note: "A short text example from X’s embed documentation.",
        },
        "demo-guide": {
          title: "Research reference",
          note: "The same linked post also appears in Guides. Each collection keeps its own context for this post.",
        },
      },
    },
  ],
  posts: [
    {
      id: "demo-guide",
      url: "https://x.com/XDevelopers/status/1346889436626259968",
      sourceKind: "x",
      sourceLabel: "X",
      authorName: "X post",
      authorHandle: "",
      title: "Timeline guide",
      context: "",
      savedAt: "2026-09-13T00:00:00.000Z",
    },
    {
      id: "demo-photo",
      url: "https://x.com/Interior/status/463440424141459456",
      sourceKind: "x",
      sourceLabel: "X",
      authorName: "X post",
      authorHandle: "",
      title: "Landscape photograph",
      context: "",
      savedAt: "2026-09-13T00:00:00.000Z",
    },
    {
      id: "demo-text",
      url: "https://x.com/jack/status/20",
      sourceKind: "x",
      sourceLabel: "X",
      authorName: "X post",
      authorHandle: "",
      title: "Short text",
      context: "",
      savedAt: "2026-09-13T00:00:00.000Z",
    },
  ],
  featured: [
    { collectionId: "demo-guides", postId: "demo-guide" },
    { collectionId: "demo-artworks", postId: "demo-photo" },
  ],
};
